import React, { useEffect } from 'react';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
// Import images
import carousel1 from '../../img/Website-Header-latest.png';
import aboutImg from '../../img/about-2.png';
import aboutImg2 from '../../img/about.png';
import service1 from '../../img/service-1.jpg';


import prod1 from '../../img/dehydrated-garlic-flakes-supplier.jpg';
import prod2 from '../../img/DRIED-WHITE-ONION-FLAKES.jpg';
import prod3 from '../../img/91DyTnfFwtL.jpg';
import prod4 from '../../img/1-12-1.jpg';
import prod5 from '../../img/1-1.jpeg';
import prod6 from '../../img/71vlBrYw5kL.jpg';

export default function Home() {
  useEffect(() => {
    Aos.init({
      duration: 1000
    });
  }, []);

  return (
    <>
   {/* Carousel Start */}
      <div className="container-fluid p-0 mb-5">
        <div id="blog-carousel" className="carousel slide overlay-bottom" data-bs-ride="carousel">
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img className="w-100" src={carousel1} alt="Coffee shop" />
              <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                <h2 className="text-primary font-weight-medium m-0">Welcome to </h2>
                <h1 className="display-1 text-white m-0">Marshal </h1>
                <h5 className="text-white m-0">Marshal herbs & spices is a leading exporter of premium quality herbs and spices, <br />
based in Egypt and serving customers worldwide</h5>
              </div>
            </div>
         
          </div>
     
        </div>
      </div>
      {/* Carousel End */}

      {/* About Start */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="section-title">
            <h4 className="text-primary text-uppercase" style={{letterSpacing: '5px'}}>About Us</h4>
            <h1 className="display-4"> Since 2000</h1>
          </div>
          <div className="row">
            <div className="col-lg-4 py-0 py-lg-5">
              <h1 className="mb-3">Our Story</h1>
              <h5 className="mb-3">Marshal herbs & spices is a leading exporter of premium quality herbs and spices, based in Egypt and serving customers worldwide. Our herbs and spices are grown and harvested using sustainable practices and are carefully processed to preserve their natural flavor and health benefits.

</h5>
              <Link to="/about" className="btn btn-secondary font-weight-bold py-2 px-4 mt-2">Learn More</Link>
            </div>
            <div className="col-lg-4 py-5 py-lg-0" style={{minHeight: '500px'}}>
              <div className="position-relative h-100">
                <img className="position-absolute w-100 h-100" src={aboutImg} alt="About us" style={{objectFit: 'cover'}} />
              </div>
            </div>
            <div className="col-lg-4 py-0 py-lg-5">
              <h1 className="mb-3">Our Vision</h1>
              <p>At marshal herbs & spices, our vision is to become a leading global supplier of premium quality herbs and spices, while fostering a culture of teamwork and collaboration among our employees, customers, and partners.

</p>
              <h5 className="mb-3"><i className="fa fa-check text-primary mr-3"></i>Offer 100% Genuine Assistance
</h5>
              <h5 className="mb-3"><i className="fa fa-check text-primary mr-3"></i>Faster & Reliable Execution
</h5>
              <h5 className="mb-3"><i className="fa fa-check text-primary mr-3"></i>Accurate & Expert Advice</h5>
              <Link to="/vision" className="btn btn-primary font-weight-bold py-2 px-4 mt-2">Learn More</Link>
            </div>
          </div>
        </div>
      </div>
             {/* Company Overview Section */}
          <div className="container-fluid py-5">
            <div className="container">
              <div className="section-title text-center">
                <h4 className="text-primary text-uppercase" style={{letterSpacing: '5px'}}>Our Journey</h4>
                <h1 className="display-4">Since 2001</h1>
              </div>
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="p-4">
                    <h2 className="mb-4">MARSHAL Herbs Foundation</h2>
                    <p className="mb-4">
                      MARSHAL Herbs was founded in 2001 to produce safe and wholesome herbs and spices suitable 
                      for export to the local market and other exporters.
                    </p>
                    <p className="mb-4">
                      By joining of new members to MARSHAL Herbs team with prolonged experience in quality, 
                      production and export of herbs and spices complying with different customers' requirements 
                      and quality standards, MARSHAL Herbs start exporting and become one of the promising companies in the market.
                    </p>
                    <p>
                      The dedication of our employees, scale of our manufacturing and support operations, 
                      long-term industry experience of our management team, and our continuing focus on producing 
                      superior products, have helped us attain significant performance advantages in our marketplace.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img className="img-fluid rounded" src={aboutImg} alt="MARSHAL Herbs facility" />
                </div>
              </div>
            </div>
          </div>

          {/* Story Behind the Name Section */}
          <div className="container-fluid bg-light py-5">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <img className="img-fluid rounded" src={aboutImg2} alt="MARSHAL Herbs team" />
                </div>
                <div className="col-lg-6">
                  <div className="p-4">
                    <h2 className="text-primary mb-4">Story Behind the Name</h2>
                    <h4 className="mb-3">MARSHAL Herbs is Specific Motivated Advanced Reliable Group</h4>
                    
                    <div className="mb-4">
                      <h6><i className="fa fa-check text-primary mr-2"></i><strong>Specific:</strong> MARSHAL Herbs owners are three partners who have more than 20 years worth of experience in the field of herbs and spices covering all the products' life cycle from plantation to export which makes them Specific.</h6>
                    </div>
                    
                    <div className="mb-4">
                      <h6><i className="fa fa-check text-primary mr-2"></i><strong>Motivated:</strong> MARSHAL Herbs team plans to lead the Egyptian market of herbs and spices specially organic products through scientific and marketing studies which makes them Motivated.</h6>
                    </div>
                    
                    <div className="mb-4">
                      <h6><i className="fa fa-check text-primary mr-2"></i><strong>Advanced:</strong> MARSHAL Herbs use the most advanced equipments in production and packaging of herbs and spices and also the most advanced studies in sustainability and food safety which makes them Advanced.</h6>
                    </div>
                    
                    <div className="mb-4">
                      <h6><i className="fa fa-check text-primary mr-2"></i><strong>Reliable:</strong> MARSHAL Herbs guarantees: systematic analyses, strict controls, cleaning procedures, after-sales guarantees. These are all aspects that make our products absolutely Reliable.</h6>
                    </div>
                    
                    <p className="mb-0">
                      <strong>MARSHAL Herbs Group</strong> is composed of our employees, our customers and our suppliers, 
                      this is our Specific, Motivated, Advanced, and Reliable Group.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* Responsibility & Commitment Section */}
          <div className="container-fluid bg-dark py-5">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="p-4 text-white">
                    <h2 className="mb-4 text-primary">Responsibility & Commitment</h2>
                    <p className="mb-4">
                      MARSHAL Herbs has a long tradition of responsibility – to our employees, our partners, 
                      and to society. This responsibility is a precondition and also a result of a value-oriented 
                      approach to corporate management.
                    </p>
                    <p className="mb-4">
                      Our entrepreneurial activities are guided by the principles of the United Nations Global Compact. 
                      In our daily work, it goes without saying that we comply with all applicable laws and respect 
                      and act in accordance with basic ethical values.
                    </p>
                    <p className="mb-4">
                      Beyond this, we have worked with our employees and business partners to develop principles 
                      and policies that specifically commit us to respecting and safeguarding human and labour 
                      rights as well as protecting the environment and counteracting corruption.
                    </p>
                    <p className="mb-0">
                      <strong>Our commitment</strong> is that our corporate responsibility doesn't end at the factory gates. 
                      In close cooperation with our suppliers and partners, we work towards implementing the labour, 
                      social and environmental standards we uphold, across the supply chain.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img className="img-fluid rounded" src={aboutImg} alt="MARSHAL Herbs responsibility" />
                </div>
              </div>
            </div>
          </div>

          {/* Stats Section */}
          <div className="container-fluid py-5">
            <div className="container">
              <div className="section-title text-center mb-5">
                <h4 className="text-primary text-uppercase" style={{letterSpacing: '5px'}}>Our Achievements</h4>
                <h1 className="display-4">MARSHAL in Numbers</h1>
              </div>
              <div className="row g-4">
                <div className="col-6 col-sm-3">
                  <div className="counter text-center">
                    <div className="counter-icon mb-2">
                      <i className="fas fa-globe text-primary fa-2x"></i>
                    </div>
                    <div className="counter-content">
                      <h6 className="mb-1">Global Markets</h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="counter-value fw-bold h4 mb-0">25</span>
                        <h6 className="text-primary mb-0" style={{ fontWeight: 600, fontSize: '20px' }}>+</h6>
                      </div>
                      <small>Countries Served</small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="counter text-center">
                    <div className="counter-icon mb-2">
                      <i className="fas fa-users text-primary fa-2x"></i>
                    </div>
                    <div className="counter-content">
                      <h6 className="mb-1">Team Members</h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="counter-value fw-bold h4 mb-0">50</span>
                        <h6 className="text-primary mb-0" style={{ fontWeight: 600, fontSize: '20px' }}>+</h6>
                      </div>
                      <small>Dedicated Professionals</small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="counter text-center">
                    <div className="counter-icon mb-2">
                      <i className="fas fa-award text-primary fa-2x"></i>
                    </div>
                    <div className="counter-content">
                      <h6 className="mb-1">Quality Standards</h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="counter-value fw-bold h4 mb-0">15</span>
                        <h6 className="text-primary mb-0" style={{ fontWeight: 600, fontSize: '20px' }}>+</h6>
                      </div>
                      <small>International Certificates</small>
                    </div>
                  </div>
                </div>
                <div className="col-6 col-sm-3">
                  <div className="counter text-center">
                    <div className="counter-icon mb-2">
                      <i className="fas fa-leaf text-primary fa-2x"></i>
                    </div>
                    <div className="counter-content">
                      <h6 className="mb-1">Product Range</h6>
                      <div className="d-flex align-items-center justify-content-center">
                        <span className="counter-value fw-bold h4 mb-0">100</span>
                        <h6 className="text-primary mb-0" style={{ fontWeight: 600, fontSize: '20px' }}>+</h6>
                      </div>
                      <small>Herbs & Spices</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="container-fluid py-5 bg-primary">
            <div className="container text-center">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <h2 className="text-white mb-4">Ready to Partner with MARSHAL?</h2>
                  <p className="text-white mb-5">
                    Join our network of satisfied customers and experience the MARSHAL difference in quality, 
                    reliability, and service excellence.
                  </p>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <Link to="/products" className="btn btn-light btn-lg w-100">
                        View Our Products
                      </Link>
                    </div>
                    <div className="col-md-6 mb-3">
                      <Link to="/contact" className="btn btn-outline-light btn-lg w-100">
                        Contact Us Today
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
      {/* About End */}
{/* Service Start */}
<div className="container-fluid py-5">
    <div className="container py-5">
         <div className="section-title">
            <h4 className="text-primary text-uppercase" style={{letterSpacing: '5px'}}>Our Services</h4>
            <h1 className="display-4"> Since 2000</h1>
          </div>
        
        {/* Service Item 1 */}
        <div className="service-item service-item-left">
            <div className="row g-0 align-items-center">
                <div className="col-md-5">
                    <div className="service-img p-5 wow fadeInRight" data-wow-delay="0.2s">
                        <img className="img-fluid rounded-circle" src={service1} alt="Fashion Shows" />
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="service-text px-5 px-md-0 py-md-5 wow fadeInRight" data-wow-delay="0.5s">
                        <h3 className="text-uppercase">
Reliable international shipping</h3>
                        <p className="mb-4">
                           We provide efficient and fast export solutions to all over the world
                        </p>
                        <Link to="/fashion-shows" className="btn btn-outline-primary border-2 px-4">
                            Read More <i className="fa fa-arrow-right ms-1"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        
        {/* Service Item 2 */}
        <div className="service-item service-item-right">
            <div className="row g-0 align-items-center">
                <div className="col-md-5 order-md-1 text-md-end">
                    <div className="service-img p-5 wow fadeInLeft" data-wow-delay="0.2s">
                        <img className="img-fluid rounded-circle" src={service1} alt="Corporate Events" />
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="service-text px-5 px-md-0 py-md-5 text-md-end wow fadeInLeft" data-wow-delay="0.5s">
                        <h3 className="text-uppercase">International export standards</h3>
                        <p className="mb-4">
                            We adhere to international standards in agriculture, storage, and shipping.
                        </p>
                        <Link to="/corporate-events" className="btn btn-outline-primary border-2 px-4">
                            Read More <i className="fa fa-arrow-right ms-1"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        
        {/* Service Item 3 */}
        <div className="service-item service-item-left">
            <div className="row g-0 align-items-center">
                <div className="col-md-5">
                    <div className="service-img p-5 wow fadeInRight" data-wow-delay="0.2s">
                        <img className="img-fluid rounded-circle" src={service1}alt="Commercial Photo Shots" />
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="service-text px-5 px-md-0 py-md-5 wow fadeInRight" data-wow-delay="0.5s">
                        <h3 className="text-uppercase">
Competitive prices</h3>
                        <p className="mb-4">
                           We offer the best prices with high-quality assurance.
                        </p>
                        <Link to="/commercial-photos" className="btn btn-outline-primary border-2 px-4">
                            Read More <i className="fa fa-arrow-right ms-1"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        
        {/* Service Item 4 */}
        <div className="service-item service-item-right">
            <div className="row g-0 align-items-center">
                <div className="col-md-5 order-md-1 text-md-end">
                    <div className="service-img p-5 wow fadeInLeft" data-wow-delay="0.2s">
                        <img className="img-fluid rounded-circle" src={service1}alt="Professional Modeling" />
                    </div>
                </div>
                <div className="col-md-7">
                    <div className="service-text px-5 px-md-0 py-md-5 text-md-end wow fadeInLeft" data-wow-delay="0.5s">
                        <h3 className="text-uppercase">High-quality products
</h3>
                        <p className="mb-4">
                            We ensure premium quality in all our agricultural exports.


                        </p>
                        <Link to="/professional-modeling" className="btn btn-outline-primary border-2 px-4">
                            Read More <i className="fa fa-arrow-right ms-1"></i>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
{/* Service End */}
 
      {/* product start */}
      <div className="container-fluid products overflow-hidden pt-5">
    <div className="container py-5">
        <div className="section-title text-center mb-5" data-aos="fade-up" data-aos-delay="100">
            <div className="sub-style">
                <h5 className="sub-title text-primary px-3 mb-3">Our Products</h5>
                <h2 className="display-6 mb-4">Premium Quality Herbs & Spices</h2>
                <p className="lead text-muted">Discover our range of carefully sourced and processed agricultural products</p>
            </div>
        </div>
        
        <div className="row g-4">
            {/* Product 1 - Dehydrated Garlic */}
            <div className="col-lg-6 col-xl-4" data-aos="fade-up" data-aos-delay="100">
                <div className="product-card">
                    <div className="product-image">
                        <img src={prod1} className="img-fluid w-100" alt="Dehydrated Garlic" />
                    </div>
                    <div className="product-content">
                        <div className="product-main-content">
                            <div className="product-category mb-2">
                                <span className="badge bg-primary-subtle text-primary">Dehydrated</span>
                            </div>
                            <h5 className="product-title mb-3">Dehydrated Garlic</h5>
                            <div className="product-basic-info">
                                <p className="mb-2"><strong>Scientific Name:</strong> Allium sativum</p>
                                <p className="mb-0"><strong>Status:</strong> <span className="badge bg-success ms-1">Organic</span></p>
                            </div>
                        </div>
                        <div className="product-details ">
                            <div className="details-content">
                                <div className="details-specs">
                                <p className="text-white mb-3"><strong>Product Details</strong></p>
                                    <p className="mb-2"><strong>Available Forms:</strong></p>
                                    <ul className="list-unstyled mb-3">
                                        <li>• Whole</li>
                                        <li>• Powder</li>
                                    </ul>
                                    <p className="mb-2"><strong>Pesticides Status:</strong></p>
                                    <ul className="list-unstyled">
                                        <li>• Conventional</li>
                                        <li>• AS Reg. EC396/2005</li>
                                        <li>• Organic</li>
                                    </ul>
                                </div>
                                <Link to="/contact" className="btn btn-light rounded-pill w-100 mt-3">
                                    Contact Us for Pricing
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Product 2 - Dehydrated Onion */}
            <div className="col-lg-6 col-xl-4" data-aos="fade-up" data-aos-delay="200">
                <div className="product-card">
                    <div className="product-image">
                        <img src={prod2} className="img-fluid w-100" alt="Dehydrated Onion" />
                    </div>
                    <div className="product-content">
                        <div className="product-main-content">
                            <div className="product-category mb-2">
                                <span className="badge bg-primary-subtle text-primary">Dehydrated</span>
                            </div>
                            <h5 className="product-title mb-3">Dehydrated Onion</h5>
                            <div className="product-basic-info">
                                <p className="mb-2"><strong>Scientific Name:</strong> Allium cepa</p>
                                <p className="mb-0"><strong>Status:</strong> <span className="badge bg-secondary ms-1">Conventional</span></p>
                            </div>
                        </div>
                        <div className="product-details">
                            <div className="details-content">
                                <div className="details-specs">
                                <p className="text-white mb-3"><strong>Product Details</strong></p>
                                    <p className="mb-2"><strong>Available Forms:</strong></p>
                                    <ul className="list-unstyled mb-3">
                                        <li>• Kibbled</li>
                                        <li>• Minced</li>
                                        <li>• Granules</li>
                                        <li>• Powder</li>
                                    </ul>
                                    <p className="mb-2"><strong>Pesticides Status:</strong></p>
                                    <ul className="list-unstyled">
                                        <li>• Conventional</li>
                                        <li>• AS Reg. EC396/2005</li>
                                        <li>• Organic</li>
                                    </ul>
                                </div>
                                <Link to="/contact" className="btn btn-light rounded-pill w-100 mt-3">
                                    Contact Us for Pricing
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Product 3 - Liquorice Roots */}
            <div className="col-lg-6 col-xl-4" data-aos="fade-up" data-aos-delay="300">
                <div className="product-card">
                    <div className="product-image">
                        <img src={prod3} className="img-fluid w-100" alt="Liquorice Roots" />
                    </div>
                    <div className="product-content">
                        <div className="product-main-content">
                            <div className="product-category mb-2">
                                <span className="badge bg-primary-subtle text-primary">Roots</span>
                            </div>
                            <h5 className="product-title mb-3">Liquorice Roots</h5>
                            <div className="product-basic-info">
                                <p className="mb-2"><strong>Scientific Name:</strong> Glycerriza glabra</p>
                                <p className="mb-0"><strong>Status:</strong> <span className="badge bg-success ms-1">Organic</span></p>
                            </div>
                        </div>
                        <div className="product-details">
                            <div className="details-content">
                                <div className="details-specs">
                                <p className="text-white mb-3"><strong>Product Details</strong></p>
                                    <p className="mb-2"><strong>Available Forms:</strong></p>
                                    <ul className="list-unstyled mb-3">
                                        <li>• Whole</li>
                                        <li>• Cut</li>
                                        <li>• TBC</li>
                                    </ul>
                                    <p className="mb-2"><strong>Pesticides Status:</strong></p>
                                    <ul className="list-unstyled">
                                        <li>• Conventional</li>
                                        <li>• AS Reg. EC396/2005</li>
                                        <li>• Organic</li>
                                    </ul>
                                </div>
                                <Link to="/contact" className="btn btn-light rounded-pill w-100 mt-3">
                                    Contact Us for Pricing
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Product 4 - Rosemary */}
            <div className="col-lg-6 col-xl-4" data-aos="fade-up" data-aos-delay="400">
                <div className="product-card">
                    <div className="product-image">
                        <img src={prod4} className="img-fluid w-100" alt="Rosemary" />
                    </div>
                    <div className="product-content">
                        <div className="product-main-content">
                            <div className="product-category mb-2">
                                <span className="badge bg-primary-subtle text-primary">Herbs</span>
                            </div>
                            <h5 className="product-title mb-3">Rosemary</h5>
                            <div className="product-basic-info">
                                <p className="mb-2"><strong>Scientific Name:</strong> Rosmarinus officinalis</p>
                                <p className="mb-0"><strong>Status:</strong> <span className="badge bg-success ms-1">Organic</span></p>
                            </div>
                        </div>
                        <div className="product-details">
                            <div className="details-content">
                                <div className="details-specs">
                                <p className="text-white mb-3"><strong>Product Details</strong></p>
                                    <p className="mb-2"><strong>Available Forms:</strong></p>
                                    <ul className="list-unstyled mb-3">
                                        <li>• Cut (different sizes)</li>
                                        <li>• Ground</li>
                                    </ul>
                                    <p className="mb-2"><strong>Pesticides Status:</strong></p>
                                    <ul className="list-unstyled">
                                        <li>• Conventional</li>
                                        <li>• AS Reg. EC396/2005</li>
                                        <li>• Organic</li>
                                    </ul>
                                </div>
                                <Link to="/contact" className="btn btn-light rounded-pill w-100 mt-3">
                                    Contact Us for Pricing
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Product 5 - Lemon Grass */}
            <div className="col-lg-6 col-xl-4" data-aos="fade-up" data-aos-delay="500">
                <div className="product-card">
                    <div className="product-image">
                        <img src={prod5} className="img-fluid w-100" alt="Lemon Grass" />
                    </div>
                    <div className="product-content">
                        <div className="product-main-content">
                            <div className="product-category mb-2">
                                <span className="badge bg-primary-subtle text-primary">Herbs</span>
                            </div>
                            <h5 className="product-title mb-3">Lemon Grass</h5>
                            <div className="product-basic-info">
                                <p className="mb-2"><strong>Scientific Name:</strong> Cymbopogon citratus</p>
                                <p className="mb-0"><strong>Status:</strong> <span className="badge bg-success ms-1">Organic</span></p>
                            </div>
                        </div>
                        <div className="product-details">
                            <div className="details-content">
                                <div className="details-specs">
                                <p className="text-white mb-3"><strong>Product Details</strong></p>
                                    <p className="mb-2"><strong>Available Forms:</strong></p>
                                    <ul className="list-unstyled mb-3">
                                        <li>• Cut (different sizes)</li>
                                        <li>• TBC</li>
                                        <li>• Powder</li>
                                    </ul>
                                    <p className="mb-2"><strong>Pesticides Status:</strong></p>
                                    <ul className="list-unstyled">
                                        <li>• Conventional</li>
                                        <li>• AS Reg. EC396/2005</li>
                                        <li>• Organic</li>
                                    </ul>
                                </div>
                                <Link to="/contact" className="btn btn-light rounded-pill w-100 mt-3">
                                    Contact Us for Pricing
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Product 6 - Verbascum */}
            <div className="col-lg-6 col-xl-4" data-aos="fade-up" data-aos-delay="600">
                <div className="product-card">
                    <div className="product-image">
                        <img src={prod6} className="img-fluid w-100" alt="Verbascum (Mullein)" />
                    </div>
                    <div className="product-content">
                        <div className="product-main-content">
                            <div className="product-category mb-2">
                                <span className="badge bg-primary-subtle text-primary">Flowers</span>
                            </div>
                            <h5 className="product-title mb-3">Verbascum (Mullein)</h5>
                            <div className="product-basic-info">
                                <p className="mb-2"><strong>Scientific Name:</strong> Verbascum thapsus</p>
                                <p className="mb-0"><strong>Status:</strong> <span className="badge bg-secondary ms-1">Conventional</span></p>
                            </div>
                        </div>
                        <div className="product-details">
                            <div className="details-content">
                                <div className="details-specs">
                                <p className="text-white mb-3"><strong>Product Details</strong></p>
                                    <p className="mb-2"><strong>Available Forms:</strong></p>
                                    <ul className="list-unstyled mb-3">
                                        <li>• Flowers</li>
                                    </ul>
                                    <p className="mb-2"><strong>Pesticides Status:</strong></p>
                                    <ul className="list-unstyled">
                                        <li>• Conventional (Out of Stock)</li>
                                    </ul>
                                </div>
                                <Link to="/contact" className="btn btn-light rounded-pill w-100 mt-3">
                                    Contact Us for Pricing
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


         
        
        </div>

        <div className="text-center mt-5 pt-4" data-aos="fade-up" data-aos-delay="100">
            <h4 className="mb-4">Explore All Our Premium Products</h4>
            <Link to="/products" className="btn btn-outline-primary btn-lg rounded-pill px-5">
                View All Products
            </Link>
        </div>
    </div>
</div>
      {/* product end */}
      {/* Service End */}
 <div className="container-fluid my-5">
      <div className="container">
          <div className="section-title text-center mb-5" data-aos="fade-up" data-aos-delay="100">
            <div className="sub-style">
                <h5 className="sub-title text-primary px-3 mb-3">Contact Us</h5>
                <h2 className="display-6 mb-4">feel free to contact us</h2>
            </div>
        </div>
        <div className="reservation position-relative overlay-top overlay-bottom">
          <div className="row align-items-center">
            <div className="col-lg-6 my-5 my-lg-0">
              <div className="p-5">
                <div className="mb-4">
                  <h1 className="display-3 text-primary">MARSHAL Herbs & Spices</h1>
                  <h1 className="text-white">For Import & Export herbs</h1>
                </div>
                <p className="text-white">
                  We specialize in high-quality medicinal and aromatic herbs. 
                  Our products are 100% natural with international quality certificates 
                  and full compliance with global export standards.
                </p>
                <ul className="list-inline text-white m-0">
                  <li className="py-2">
                    <i className="fa fa-check text-primary mr-3"></i>
contact@marshal.com                  </li>
                  <li className="py-2">
                    <i className="fa fa-check text-primary mr-3"></i>
01222461667                  </li>
                  <li className="py-2">
                    <i className="fa fa-check text-primary mr-3"></i>
Somosta- Bani Swayf - Egypt                  </li>
                </ul>
                <div className="mt-4">
                  <Link to="/products" className="text-primary font-weight-bold">
                    View All Products →
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div 
                className="text-center p-5" 
                style={{ background: 'rgba(51, 33, 29, .8)' }}
              >
                <h1 className="text-white mb-4 mt-5">Contact MARSHAL</h1>
                <form className="mb-5">
                  <div className="form-group">
                    <input 
                      type="text" 
                      className="form-control bg-transparent border-primary p-4" 
                      placeholder="Full Name"
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <input 
                      type="email" 
                      className="form-control bg-transparent border-primary p-4" 
                      placeholder="Email Address"
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <input 
                      type="tel" 
                      className="form-control bg-transparent border-primary p-4" 
                      placeholder="Phone Number"
                      required 
                    />
                  </div>
                  <div className="form-group">
                    <select className="custom-select bg-transparent border-primary px-4" style={{ height: '49px' }}>
                      <option selected>Inquiry Type</option>
                      <option value="import">Import</option>
                      <option value="export">Export</option>
                      <option value="product">Product Information</option>
                      <option value="other">Other Inquiry</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <textarea 
                      className="form-control bg-transparent border-primary p-4" 
                      placeholder="Your Message"
                      rows="3"
                    ></textarea>
                  </div>
                  
                  <div>
                    <button className="btn btn-primary btn-block font-weight-bold py-3" type="submit">
                      Send Message
                    </button>
                  </div>
                </form>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

{/* Google Map Start */}
<div className="container-fluid p-0 wow fadeIn" data-wow-delay="0.3s">
    <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
        frameBorder="0" allowFullScreen="" aria-hidden="false" tabIndex="0"
        style={{width: "100%", height: "500px", filter: "grayscale(100%) invert(92%) contrast(83%)", border: "0"}}></iframe>
</div>
{/* Google Map End */}

    </>
  );
}